import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Home, Building } from 'lucide-react';
import { useConfigurator } from '../ConfiguratorProvider';
import { roofTypes } from '../productData';

export const RoofTypeSelection = () => {
  const { configuration, setConfiguration } = useConfigurator();

  const handleRoofTypeSelect = (roofType: typeof roofTypes[0]) => {
    setConfiguration({ roofType, mountingSystem: undefined }); // Reset mounting system when roof type changes
  };

  const getRoofIcon = (roofId: string) => {
    switch (roofId) {
      case 'flat-roof':
        return Building;
      default:
        return Home;
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-2xl font-bold mb-2">Wat voor dak heb je?</h3>
        <p className="text-muted-foreground">
          Het daktype bepaalt welk montagesysteem we gebruiken
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {roofTypes.map((roofType) => {
          const IconComponent = getRoofIcon(roofType.id);
          
          return (
            <Card 
              key={roofType.id}
              className={`cursor-pointer transition-all hover:shadow-md ${
                configuration.roofType?.id === roofType.id 
                  ? 'ring-2 ring-primary bg-primary/5' 
                  : ''
              }`}
              onClick={() => handleRoofTypeSelect(roofType)}
            >
              <CardHeader>
                <CardTitle className="text-lg flex items-center gap-3">
                  <IconComponent className="h-6 w-6 text-primary" />
                  {roofType.name}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-sm leading-relaxed">
                  {roofType.description}
                </CardDescription>
                
                {configuration.roofType?.id === roofType.id && (
                  <Button className="w-full mt-4" variant="secondary">
                    Geselecteerd ✓
                  </Button>
                )}
              </CardContent>
            </Card>
          );
        })}
      </div>

      {configuration.roofType && (
        <Card className="bg-primary/5 border-primary/20">
          <CardContent className="pt-6">
            <div className="flex items-center gap-2 mb-2">
              <Home className="h-4 w-4 text-primary" />
              <span className="font-medium">Jouw selectie:</span>
            </div>
            <p className="text-sm text-muted-foreground">
              {configuration.roofType.name} - {configuration.roofType.description}
            </p>
          </CardContent>
        </Card>
      )}
    </div>
  );
};